import { Link } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import get from 'lodash.get'
import React from 'react'
import styled from 'styled-components'

export const CustomCarousel = (slides) => {
    const tile = (item, index) => {
        const { uid } = item
        const { title, cover } = item.data
        const { alt, thumbnails } = cover
        const imagePortrait = get(thumbnails, 'cover_portrait.localFile.childImageSharp.gatsbyImageData')

        return (
            <Link to={`/business-case/${uid}`} key={`${title.text}-${index}`}>
                <StyledSlide className={'slideCustom'}>
                    <StyledImage alt={alt || title.text} image={imagePortrait} />
                    <StyledLabelContainer>
                        <StyledLabel>{title.text}</StyledLabel>
                    </StyledLabelContainer>
                </StyledSlide>
            </Link>
        )
    }
    const items = slides.slides.map((item, index) => tile(item, index))

    if ( slides.length === 0 ) return

    return (
        <StyledContainer>
            <StyledHorizontalZone>
                <StyledHorizontalContent>
                    {items}
                </StyledHorizontalContent>
            </StyledHorizontalZone>
        </StyledContainer>
    )
}

const StyledSlide = styled.div`
  height: 400px;
  width: 225px;
  border-radius: 20px;
  overflow: hidden;
  position: relative;
  margin: 0 8px;
  transition: scale 0.5s;

  &:hover {
    scale: 1.1;
    z-index: 2;
  }
`

const StyledImage = styled(GatsbyImage)`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

const StyledLabelContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(0, 0, 0, 0.55) 100%);
  color: white;
  text-align: center;
`

const StyledLabel = styled.p`
  margin: 0;
  font-size: 18px;
  font-weight: bold;
  padding: 10px;
`

const StyledContainer = styled.div`
  max-width: 1140px;
  margin: 0 auto -1rem;
  padding: 0 20px;
  position: relative;
`

const StyledHorizontalZone = styled.div`
  width: 100vw;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  overflow-x: auto;
  padding: 20px;

  /* Hide scrollbar */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari and Opera */
  }
`

const StyledHorizontalContent = styled.div`
  display: inline-flex;
  padding: 0 calc((100vw - 1150px) / 2);
  gap: 10px;
  width: max-content;
`